<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <!-- TABLA DOCUMENTO -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-destruccion
                :key="gridDocumento"
                :rowsTable="rowsTable"
                :contratoId="contratoId"
              ></grid-destruccion>
              <!-- <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text">En construcción</v-toolbar-title>
            </v-toolbar>           -->
            </template>
            <!-- TABLA DOCUMENTO -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridDestruccion from "@/modules/captura/views/destruccion/GridDestruccion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "destruccion-seleccion-tab",

  components: {
    Loading,
    GridDestruccion,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      selectedTab: "tab-1",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
